module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 636
// module chunks = 0